var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCashBooking(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 23,
    viewBox: "0 0 17 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.9268 1.6049H2.47258C2.01191 1.56305 1.07431 2.33304 1.00928 3.4043V20.6029",
    stroke: "#202124",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9266 1.60474V19.3474H2.83823C2.17433 19.3195 0.879037 19.6319 1.00911 21.1049C0.968461 21.3839 1.12292 21.9921 2.06594 22.1929L15.9266 21.9837",
    stroke: "#202124",
    strokeWidth: 1.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9267 19.3899C15.6828 19.7805 15.3414 20.8378 15.9267 21.9425",
    stroke: "#202124",
    strokeWidth: 1.5
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M4.95215 15.3723H13.3661",
    stroke: "#202124",
    strokeWidth: 1.5
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M12 5.85203L11.7009 6.90163H6L6.29912 5.85203H12ZM9.32551 12.9278L6.10557 8.87415L6.08798 8.1141H7.68915C8.10557 8.1141 8.46041 8.05377 8.75367 7.93313C9.04692 7.80947 9.27126 7.62549 9.42669 7.38119C9.58211 7.13387 9.65982 6.82321 9.65982 6.44922C9.65982 5.89727 9.49853 5.46446 9.17595 5.15079C8.85337 4.8341 8.35777 4.67576 7.68915 4.67576H6L6.29912 3.66235H7.68915C8.40469 3.66235 8.9912 3.7845 9.44868 4.02881C9.90909 4.27009 10.2493 4.60186 10.4692 5.02412C10.6921 5.44335 10.8035 5.91839 10.8035 6.44922C10.8035 6.92877 10.7009 7.37063 10.4956 7.77479C10.2933 8.17593 9.96774 8.49865 9.51906 8.74295C9.07331 8.98725 8.48387 9.1094 7.75073 9.1094H7.72434L10.6979 12.8554V12.9278H9.32551ZM12 3.66235L11.7009 4.71195L7.21408 4.67576L7.5132 3.66235H12Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCashBooking);
export default __webpack_public_path__ + "static/media/cashBooking.d4eb4add19a8e6f16d377e4a140d9b9b.svg";
export { ForwardRef as ReactComponent };